export const isInactive = (profile) => {
  return profile && profile.status === "INACTIVE";
};

const isWaitListed = (profile) => {
  return profile?.is_wait_listed === true;
};

const hasAcknowledgedHCPDI = (profile) => {
  return profile?.acknowledgements?.hcp_di_reminder ?? false;
};

const shouldShowHCPDIModal = (profile) => {
  return (
    profile &&
    profile.group_type === "hcp_program" &&
    profile.schedule_video_call &&
    !hasAcknowledgedHCPDI(profile) &&
    !isInactive(profile)
  );
};

const shouldShowInactiveModal = (profile) => {
  return isInactive(profile);
};

const shouldShowWaitListModal = (profile) => {
  return isWaitListed(profile);
};

export const shouldShowFamilyMembersWidget = (profile) => {
  return !!(
    (profile?.enriched_associated_wards ?? []).length ||
    (profile?.enriched_associated_guardians ?? []).length
  );
};
